<template>
  <div>
    <send-tax-return-dialog
      :opened.sync="sendSignatureRequestDialogOpened"
      :signatureRequest="signatureRequest"
      :sending="sending"
      @send="send"
    />

    <send-e-filed-return-dialog
      :opened.sync="sendEFiledReturnDialogOpened"
      :signatureRequest="signatureRequest"
      :sending="sending"
      @send="send"
    />

    <error-message-dialog
      :opened.sync="errorMessageDialogOpened"
      :message="errorMessage"
    />

    <v-dialog
      persistent
      fullscreen
      lazy
      v-model="opened"
      @keydown.esc="closeDialog"
    >
      <v-card v-if="signatureRequest" flat class="content-container">
        <v-card-title class="title pb-0 mx-2">
          <v-layout v-if="editingFormName" align-center>
            <v-text-field
              v-model="newFormName"
              solo
              hide-details
              class="default-input"
              style="max-width: 280px"
            />
            <span class="mx-1" style="font-size: 16px">.pdf</span>

            <v-btn
              color="primary"
              class="text-none ml-2"
              @click="saveEditFormName"
            >
              Save
            </v-btn>
            <v-btn
              outline
              color="primary"
              class="text-none"
              @click="cancelEditFormName"
            >
              Cancel
            </v-btn>
          </v-layout>

          <span v-else>
            {{ signatureRequest.form_name }}
            <v-icon @click="editFormName"> edit </v-icon>
          </span>

          <v-spacer />
          <v-alert
            type="success"
            :value="true"
            outline
            small
            class="py-2"
            v-if="signatureRequest.status === 'signed'"
          >
            All signers haves signed this document.
          </v-alert>
          <v-alert
            type="success"
            :value="true"
            outline
            small
            class="py-2"
            v-if="signatureRequest.status === 'completed'"
          >
            This signature request is marked as completed.
          </v-alert>
          <v-spacer />

          <v-btn
            v-if="
              signatureRequest.status !== 'completed' &&
                signatureRequest.status !== 'signed'
            "
            color="primary"
            outline
            class="text-none"
            @click="save"
          >
            Save
          </v-btn>

          <v-tooltip bottom>
            <v-btn
              v-if="isSendDisabled && isSignatureRequestCompletedOrSigned"
              color="primary"
              class="text-none"
              @click="sendEFiledReturnDialogOpened = true"
              :disabled="isSendDisabled"
            >
              Send
            </v-btn>

            <span
              >No signature requests will be sent since no signatures are
              required.</span
            >
          </v-tooltip>

          <v-btn
            v-if="!isSendDisabled && isSignatureRequestCompletedOrSigned"
            color="primary"
            class="text-none"
            @click="sendEFiledReturnDialogOpened = true"
          >
            Send
          </v-btn>

          <v-menu
            v-if="isSignatureRequestCompletedOrSigned"
            transition="slide-y-transition"
            bottom
            left
            nudge-bottom="30"
            class="my-1"
          >
            <v-btn slot="activator" color="primary" class="text-none">
              Download
            </v-btn>

            <v-list>
              <v-list-tile
                @click="$emit('download-document', signatureRequest)"
              >
                <v-list-tile-title> Download (all pages) </v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                v-if="signatureRequest.signed_pages_only !== null"
                @click="$emit('download-signed-pages-only', signatureRequest)"
              >
                <v-list-tile-title>
                  Download (signed pages only)
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-tooltip v-else-if="isSendDisabled" bottom>
            <v-btn
              color="primary"
              class="text-none"
              @click="sendSignatureRequestDialogOpened = true"
              :disabled="isSendDisabled"
              slot="activator"
            >
              <span>Send</span>
            </v-btn>

            <span
              >No signature requests will be sent since no signatures are
              required.</span
            >
          </v-tooltip>

          <v-btn
            v-else
            color="primary"
            class="text-none"
            @click="sendSignatureRequestDialogOpened = true"
          >
            <span>Send</span>
          </v-btn>

          <v-btn
            small
            fab
            flat
            class="white error--text text-capitalize ma-0"
            @click="closeDialog"
          >
            <v-icon size="20"> clear </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-layout class="return-container">
            <v-layout class="sidebar column text-xs-left">
              <div class="mb-2">Pages contain signatures:</div>

              <ul class="page-list">
                <li v-for="page in pagesContainSignatures">
                  <a
                    @click="currentPage = page"
                    :style="currentPage === page ? 'color: #333;' : ''"
                  >
                    Page {{ page }}
                    <span v-if="!isEmpty(pages[page])"
                      >({{ pages[page].name }})</span
                    >
                  </a>
                </li>
              </ul>
            </v-layout>

            <div class="pdf-container">
              <v-layout class="toolbar" justify-center align-center>
                <div class="d-flex align-center">
                  <v-icon
                    class="grey--text text--darken-1 mr-1"
                    style="cursor: pointer"
                    @click="currentPage -= 1"
                    :disabled="currentPage === 1"
                    large
                    >keyboard_arrow_left</v-icon
                  >

                  <v-layout
                    class="grey--text text--darken-3 subheading font-weight-bold"
                    align-center
                    shrink
                  >
                    Page:
                    <v-text-field
                      type="number"
                      :value="currentPage"
                      class="page-input mx-2"
                      solo
                      @change="currentPage = parseInt($event)"
                      hide-details
                    />
                    / {{ pageCount }}
                  </v-layout>

                  <v-icon
                    class="grey--text text--darken-1 mx-1"
                    style="cursor: pointer"
                    @click="currentPage += 1"
                    :disabled="currentPage === pageCount"
                    large
                    >keyboard_arrow_right</v-icon
                  >
                </div>
              </v-layout>

              <v-container class="pdf">
                <v-layout
                  py-3
                  align-center
                  style="justify-content: space-between"
                >
                  <v-layout class="mr-5" style="max-width: 350px" align-center>
                    <span class="mr-2" style="font-size: 16px">Form:</span>
                    <v-select
                      solo
                      hide-details
                      class="default-input"
                      :items="formDefinitions"
                      :item-text="
                        item => item.name + (item.id ? ' - ' + item.id : '')
                      "
                      item-value="id"
                      :value="
                        pages[currentPage] ? pages[currentPage].id : 'other'
                      "
                      @change="setForm($event)"
                    />
                  </v-layout>

                  <div class="d-flex align-center">
                    <span style="font-size: 16px">Signers on this page:</span>

                    <v-layout>
                      <v-checkbox
                        :input-value="hasTaxpayerSignature"
                        label="Taxpayer"
                        class="checkbox ml-4"
                        @change="toggleSignature($event, 'Taxpayer')"
                        :disabled="
                          taxpayerSigned ||
                            signatureRequest.status === 'completed'
                        "
                        hide-details
                      />

                      <v-checkbox
                        v-if="spouseAccount !== null"
                        :input-value="hasSpouseSignature"
                        ref="spouseCheckbox"
                        label="Spouse"
                        class="checkbox ml-4"
                        @change="toggleSignature($event, 'Spouse')"
                        :disabled="
                          spouseSigned ||
                            signatureRequest.status === 'completed'
                        "
                        hide-details
                      />
                    </v-layout>
                  </div>
                </v-layout>

                <pdf
                  @num-pages="pageCount = $event"
                  @page-loaded="
                    currentPage = $event;
                    previewLoading = false;
                    pdfLoaded = true;
                  "
                  @progress="pdfProgress = $event"
                  :page="currentPage"
                  :src="pdfSrc"
                />

                <v-layout
                  v-for="(signature, index) in signaturesOnCurrentPage"
                  :key="index"
                  v-if="pdfLoaded"
                >
                  <v-layout
                    class="signature-container"
                    :data-signatureid="index"
                    :style="
                      'bottom:' +
                        signature.signatureBottom +
                        'px;left:' +
                        signature.signatureLeft +
                        'px'
                    "
                  >
                    <img
                      v-if="signature.signatureType === 'image'"
                      :style="
                        'width:' +
                          signature.signatureWidth +
                          'px; height:' +
                          signature.signatureHeight +
                          'px'
                      "
                      :src="signature.signatureData"
                    />

                    <v-layout
                      v-else-if="signature.signatureType === 'text'"
                      align-center
                      justify-center
                      :style="
                        'width:' +
                          signature.signatureWidth +
                          'px; height:' +
                          signature.signatureHeight +
                          'px'
                      "
                    >
                      <span
                        class="signature-text"
                        :style="
                          'font-size:' + signature.signatureTextSize + 'px'
                        "
                      >
                        {{ signature.signatureData }}
                      </span>
                    </v-layout>

                    <v-layout
                      v-else
                      align-center
                      justify-center
                      :style="
                        'width:' +
                          signature.signatureWidth +
                          'px; height:' +
                          signature.signatureHeight +
                          'px'
                      "
                    >
                      <v-btn
                        color="info"
                        block
                        class="sign-here-button text-capitalize"
                        @click=""
                        :style="
                          'font-size:' +
                            (signature.signatureTextSize - 10) +
                            'px'
                        "
                      >
                        Sign here ({{ signature.title }})
                      </v-btn>
                    </v-layout>
                  </v-layout>

                  <v-layout
                    class="signature-date-container"
                    :data-signatureid="index"
                    :style="
                      'bottom:' +
                        signature.signatureDateBottom +
                        'px; left:' +
                        signature.signatureDateLeft +
                        'px'
                    "
                  >
                    <span
                      v-if="signature.signatureData"
                      class="signature-date"
                      :style="
                        'font-size:' + (signature.signatureTextSize - 10) + 'px'
                      "
                    >
                      {{ signature.signatureDate }}
                    </span>

                    <span
                      v-else
                      class="sign-here-button"
                      :style="
                        'font-size:' + (signature.signatureTextSize - 16) + 'px'
                      "
                    >
                      Date ({{ signature.title }})
                    </span>
                  </v-layout>
                </v-layout>

                <div v-else>
                  <v-progress-circular
                    indeterminate
                    size="25"
                    color="primary"
                  ></v-progress-circular>
                </div>
              </v-container>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import API from '@/api';
import interact from 'interactjs';
import uniq from 'lodash/uniq';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import SendTaxReturnDialog from '@/components/dialogs/SendTaxReturnDialog';
import SendEFiledReturnDialog from '@/components/dialogs/SendEFiledReturnDialog';
import ErrorMessageDialog from '@/components/dialogs/ErrorMessageDialog';

export default {
  components: {
    pdf,
    SendTaxReturnDialog,
    SendEFiledReturnDialog,
    ErrorMessageDialog,
  },

  props: {
    opened: {
      type: Boolean,
    },

    currentCompany: {
      type: Object,
    },

    signatureRequest: {
      type: Object,
    },
  },

  data() {
    return {
      sendSignatureRequestDialogOpened: false,
      sendEFiledReturnDialogOpened: false,
      previewLoading: false,
      currentPage: 1,
      pageCount: 1,
      pdfProgress: 0,
      pdfLoaded: false,
      pdfSrc: null,
      sending: false,
      spouseAccount: null,

      editingFormName: false,
      newFormName: '',

      errorMessage: '',
      errorMessageDialogOpened: false,

      signatures: [],
      pages: {},
      formDefinitions: [],

      defaultTaxpayerSignature: {
        title: 'Taxpayer',
        pageWidth: 1000,
        pageHeight: 1294,
        signatureWidth: 300,
        signatureHeight: 100,
        signatureBottom: 1200,
        signatureLeft: 0,
        signatureTextSize: 32,
        signatureDateLeft: 400,
        signatureDateBottom: 1220,
      },

      defaultSpouseSignature: {
        title: 'Spouse',
        pageWidth: 1000,
        pageHeight: 1294,
        signatureWidth: 300,
        signatureHeight: 100,
        signatureBottom: 1000,
        signatureLeft: 0,
        signatureTextSize: 32,
        signatureDateLeft: 400,
        signatureDateBottom: 1020,
      },
    };
  },

  methods: {
    isEmpty,

    editFormName() {
      this.newFormName = this.formNameWithoutExtension;
      this.editingFormName = true;
    },

    cancelEditFormName() {
      this.editingFormName = false;
    },

    async saveEditFormName() {
      await API.signatureRequest.updateSignatureRequest({
        companyId: this.currentCompany.id,
        id: this.signatureRequest.id,
        formName: this.newFormName + '.pdf',
      });

      this.$store.dispatch('application/setSuccessNotification', {
        message: `Saved successfully!`,
      });

      this.signatureRequest.form_name = this.newFormName + '.pdf';

      this.$emit('refresh-table');

      this.editingFormName = false;
    },

    async save() {
      await API.signatureRequest.updateSignatureRequest({
        companyId: this.currentCompany.id,
        id: this.signatureRequest.id,
        signatures: this.signatures,
        pages: this.pages,
      });

      this.$store.dispatch('application/setSuccessNotification', {
        message: `Saved successfully!`,
      });

      this.$emit('refresh-table');
    },

    async send(options) {
      this.sending = true;

      try {
        if (options.mode === 0) {
          const {
            subject,
            message,
            includeWatermark,
            saveSubjectForFutureUse,
            saveMessageForFutureUse,
          } = options;

          await API.signatureRequest.sendSignatureRequest({
            companyId: this.currentCompany.id,
            id: this.signatureRequest.id,
            signatures: this.signatures,
            pages: this.pages,
            subject: subject,
            message: message,
            includeWatermark: includeWatermark,
            saveSubjectForFutureUse,
            saveMessageForFutureUse,
          });

          this.$store.dispatch('application/setSuccessNotification', {
            message: `You have successfully sent signature request!`,
          });

          this.closeDialog();
          this.$emit('refresh-table-until-sent', this.signatureRequest.id);
        } else {
          const {
            subject,
            message,
            path,
            documentName,
            saveSubjectForFutureUse,
            saveMessageForFutureUse,
          } = options;

          await API.signatureRequest.sendTaxReturn({
            companyId: this.currentCompany.id,
            id: this.signatureRequest.id,
            subject: subject,
            message: message,
            path: path,
            documentName: documentName,
            saveSubjectForFutureUse,
            saveMessageForFutureUse,
          });

          this.$store.dispatch('application/setSuccessNotification', {
            message: `You have successfully sent tax return!`,
          });

          this.closeDialog();
          this.$emit('refresh-table-until-sent', this.signatureRequest.id);
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem sending signature request.`,
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.sending = false;
        this.sendSignatureRequestDialogOpened = false;
        this.sendEFiledReturnDialogOpened = false;
      }
    },

    async getSpouse() {
      this.spouseAccount = undefined;

      try {
        const { data: spouseAccount } = await API.company.getSpouse(
          this.currentCompany.id,
        );
        this.spouseAccount = spouseAccount;
      } catch (error) {
        this.spouseAccount = null;
      }
    },

    async toggleSignature(on, title) {
      if (on) {
        if (title === 'Spouse' && !this.spouseHasAccess) {
          this.errorMessage =
            'Error: Cannot add a signature box for the spouse because the spouse does not have access to Soraban portal. Please go to Edit Client dialog to turn on "Needs dashboard access" for the spouse\'s account.';
          this.errorMessageDialogOpened = true;
          this.removeSignature(title);
          this.$refs.spouseCheckbox.reset();
        } else {
          this.addSignature(title);
        }
      } else {
        this.removeSignature(title);
      }
    },

    async addSignature(title) {
      const signature = this.signatures.find(
        s => (s.title === title) & (s.page === this.currentPage),
      );

      if (signature) {
        return;
      }

      if (title === 'Spouse' && !this.spouseHasAccess) {
        return;
      }

      const page = this.pages[this.currentPage];

      const form = page
        ? this.formDefinitions.find(f => f.id === page.id)
        : null;

      const pdfContainer = document.querySelector('.pdf');
      const { height: pageHeight } = pdfContainer.getBoundingClientRect();

      const newSignature =
        title === 'Taxpayer'
          ? form && form.taxpayer_signature
            ? form.taxpayer_signature
            : {
                ...this.defaultTaxpayerSignature,
                signatureBottom: pageHeight - 200,
                signatureDateBottom: pageHeight - 150,
              }
          : form && form.spouse_signature
          ? form.spouse_signature
          : {
              ...this.defaultSpouseSignature,
              signatureBottom: pageHeight - 300,
              signatureDateBottom: pageHeight - 250,
            };

      const account = this.getAccountByTitle(title);

      this.signatures.push({
        ...newSignature,

        page: this.currentPage,
        userId: account.id,
      });

      this.renderSignatures();
    },

    getAccountByTitle(title) {
      if (
        this.spouseAccount &&
        this.spouseAccount.email == this.currentCompany.user.email
      ) {
        return this.currentCompany.user;
      } else {
        if (title === 'Taxpayer') {
          if (this.spouseAccount && this.spouseAccount.is_taxpayer) {
            return this.spouseAccount;
          } else {
            return this.currentCompany.user;
          }
        } else if (title === 'Spouse') {
          if (this.spouseAccount) {
            if (!this.spouseAccount.is_taxpayer) {
              return this.spouseAccount;
            } else {
              return this.currentCompany.user;
            }
          } else {
            throw new Error('Spouse account not found.');
          }
        }
      }
    },

    async removeSignature(title) {
      this.signatures = this.signatures.filter(
        s => s.page !== this.currentPage || s.title !== title,
      );

      this.renderSignatures();
    },

    async downloadPdf(source) {
      const response = await API.integration.downloadDocument({
        companyId: this.currentCompany.id,
        link: source,
      });

      if (response.data.document) {
        this.pdfSrc = response.data.document.data.link;
      }
    },

    async setForm(formId) {
      const form = this.formDefinitions.find(form => form.id === formId);

      if (form) {
        this.pages[this.currentPage] = {
          id: form.id,
          name: form.name,
        };

        if (form.taxpayer_signature && !this.hasTaxpayerSignature) {
          this.addSignature('Taxpayer');
        }

        if (
          this.spouseHasAccess &&
          form.spouse_signature &&
          !this.hasSpouseSignature
        ) {
          this.addSignature('Spouse');
        }
      }
    },

    async renderSignatures() {
      const pdfContainer = document.querySelector('.pdf');
      const {
        width: pageWidth,
        height: pageHeight,
      } = pdfContainer.getBoundingClientRect();

      this.signatures = this.signatures.map(signature => {
        const ratio = pageWidth / signature.pageWidth;

        return {
          ...signature,
          pageWidth,
          pageHeight,
          signatureWidth: signature.signatureWidth * ratio,
          signatureHeight: signature.signatureHeight * ratio,
          signatureBottom: signature.signatureBottom * ratio,
          signatureLeft: signature.signatureLeft * ratio,
          signatureTextSize: signature.signatureTextSize * ratio,
          signatureDateBottom: signature.signatureDateBottom * ratio,
          signatureDateLeft: signature.signatureDateLeft * ratio,
        };
      });

      interact('.signature-container').draggable({
        listeners: {
          move: event => {
            const index = parseInt(event.target.dataset['signatureid']);
            const signature = this.signaturesOnCurrentPage[index];

            if (!signature.signatureData) {
              const newLeft = signature.signatureLeft + event.dx;
              const newBottom = signature.signatureBottom - event.dy;

              signature.signatureLeft = newLeft;
              signature.signatureBottom = newBottom;

              event.target.style.left = newLeft + 'px';
              event.target.style.bottom = newBottom + 'px';
            }
          },
        },
      });

      interact('.signature-date-container').draggable({
        listeners: {
          move: event => {
            const index = parseInt(event.target.dataset['signatureid']);
            const signature = this.signaturesOnCurrentPage[index];

            if (!signature.signatureDate) {
              const newLeft = signature.signatureDateLeft + event.dx;
              const newBottom = signature.signatureDateBottom - event.dy;

              signature.signatureDateLeft = newLeft;
              signature.signatureDateBottom = newBottom;

              event.target.style.left = newLeft + 'px';
              event.target.style.bottom = newBottom + 'px';
            }
          },
        },
      });
    },

    closeDialog() {
      // When this dialog is embededed in iframe, we dispatch an event
      // so that the parent window can close it
      if (this.isEmbeddedInNext && this.isInIframe) {
        const event = new CustomEvent('closeDialog');
        window.parent.document.dispatchEvent(event);
      } else {
        this.$emit('update:opened', false);
      }
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),

    isSendDisabled() {
      return !this.signatures || this.signatures.length === 0;
    },

    isSignatureRequestCompletedOrSigned() {
      return (
        this.signatureRequest.status === 'completed' ||
        this.signatureRequest.status === 'signed'
      );
    },

    pagesContainSignatures() {
      const pages = this.signatures.map(s => s.page).sort((a, b) => a - b);

      return uniq(pages);
    },

    signaturesOnCurrentPage() {
      return this.signatures.filter(s => s.page === this.currentPage);
    },

    spouseHasAccess() {
      // Also allow access if spouse email is same as spouse
      return (
        this.spouseAccount &&
        ((this.spouseAccount.uid && this.spouseAccount.paying) ||
          this.spouseAccount.email === this.currentCompany.user.email)
      );
    },

    hasTaxpayerSignature() {
      const signature = this.signatures.find(
        s => s.title === 'Taxpayer' && s.page === this.currentPage,
      );
      return typeof signature !== 'undefined';
    },

    hasSpouseSignature() {
      const signature = this.signatures.find(
        s => s.title === 'Spouse' && s.page === this.currentPage,
      );
      return typeof signature !== 'undefined';
    },

    taxpayerSigned() {
      const signature = this.signatures.find(
        s => s.title === 'Taxpayer' && s.page === this.currentPage,
      );
      return typeof signature !== 'undefined' && signature.signatureData;
    },

    spouseSigned() {
      const signature = this.signatures.find(
        s => s.title === 'Spouse' && s.page === this.currentPage,
      );
      return typeof signature !== 'undefined' && signature.signatureData;
    },

    formNameWithoutExtension() {
      return this.signatureRequest.form_name.replace(/\.[^/.]+$/, '');
    },
  },

  watch: {
    currentPage: {
      async handler(value) {
        setTimeout(async () => {
          await this.renderSignatures();
        }, 500);
      },
    },

    pdfLoaded: {
      async handler(value) {
        // After pdf is loaded, it takes sometime for the pdf to show up
        setTimeout(async () => {
          await this.renderSignatures();
        }, 500);
      },
    },

    'signatureRequest.source': {
      async handler(value) {
        this.pdfSrc = null;
        this.pdfLoaded = false;
        await this.downloadPdf(value);
      },
    },

    opened: {
      async handler(value) {
        if (value) {
          await this.downloadPdf(this.signatureRequest.source);

          await this.getSpouse();

          window.addEventListener('resize', this.renderSignatures);
          this.signatures = this.signatureRequest.signatures;
          this.pages = this.signatureRequest.pages || {};
          this.currentPage = 1;

          setTimeout(async () => {
            await this.renderSignatures();
          }, 500);

          this.$store.dispatch('setCurrentFirm');
        } else {
          window.removeEventListener('resize', this.renderSignatures);
        }
      },
    },
  },

  async created() {
    const response = await API.signatureRequest.getFormDefinitions();

    this.formDefinitions = response.data.concat({
      id: 'other',
      name: 'Other',
      taxpayer_signature: null,
      spouse_signature: null,
    });
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
}

.content-container {
  height: calc(100vh - 90px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-content {
  flex: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-top: 1px solid #ccc;
  padding: 0;
  margin-top: 12px;
}

.return-container {
  min-height: 0;
}

.sidebar {
  overflow: auto;
  flex: 0;
  min-width: 240px;
  font-size: 16px;
  border-right: 1px solid #ccc;
  padding: 20px;
}

.sidebar::-webkit-scrollbar {
  -webkit-appearance: none;
  appearance: none;
}

.sidebar::-webkit-scrollbar:vertical {
  width: 8px;
}

.sidebar::-webkit-scrollbar-thumb {
  border-radius: 5px;
  border: 1px solid white;
  background-color: rgba(0, 0, 0, 0.5);
}

.pdf-container {
  overflow: auto;
  flex: auto;
  background-color: #ebebeb;
}

.pdf-container::-webkit-scrollbar {
  -webkit-appearance: none;
  appearance: none;
}

.pdf-container::-webkit-scrollbar:vertical {
  width: 11px;
}

.pdf-container::-webkit-scrollbar:horizontal {
  height: 11px;
}

.pdf-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #ebebeb; /* should match background */
  background-color: rgba(0, 0, 0, 0.5);
}

/* Fallback for Firefox and other browsers */
.pdf-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.5) #ebebeb;
}

.toolbar {
  background-color: #ebebeb;
  border-bottom: 1px solid #bbb;
  padding: 8px 16px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.pdf {
  position: relative;
  padding: 0;
  max-width: 1000px;
}

.page-list li {
  padding: 4px 0px;
}

.page-input >>> .v-input__control .v-input__slot {
  border-radius: 4px;
}

.page-input >>> .v-input__control {
  min-height: 20px;
}

.page-input >>> input {
  width: 32px;
}

.page-input >>> input::-webkit-outer-spin-button,
.page-input >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
}
.page-input >>> input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.signature-container {
  position: absolute;
}

.signature-date-container {
  position: absolute;
}

.signature-date-container > .sign-here-button {
  background: #f1f13a;
  text-align: center;
  padding: 6px 12px;
  border-radius: 4px;
}

.signature-text {
  font-family: 'Zeyada', cursive;
}

.signature-date {
  font-family: 'Mali', cursive;
}

.sign-here-button {
  cursor: move;
  opacity: 0.8;
  width: 25%;
  height: 65%;
  width: 100%;
}

.checkbox {
  margin-top: 0px;
  padding-top: 0px;
  flex: 0;
}

.checkbox >>> .v-icon {
  color: #555;
}
</style>
